import type { PageStoryblok } from "@/component-types-sb";
import type { Dictionary } from "@/lib/types";
import { StoryblokComponent, storyblokEditable } from "@storyblok/react/rsc";

type PageProps = {
  blok: PageStoryblok;
  dict?: Dictionary;
};

const Page = ({ blok, dict }: PageProps) => (
  <article className="w-full" {...storyblokEditable(blok)}>
    <header>
      {blok.header?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </header>

    {blok.body?.map((nestedBlok) => (
      <StoryblokComponent blok={nestedBlok} dict={dict} key={nestedBlok._uid} />
    ))}

    {blok.footer?.map((nestedBlok) => (
      <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
    ))}
  </article>
);

export default Page;
